export const environment = {
  production: true,
  deployment: 'prod',
  location: 'prod-ext'
};
